/**
 * Search term state for the external PA orders table, optionally hydrated from table context.
 */
import { useState } from "react";
import { useTablesContext } from "../../../../../context/tablesContextProvider";

const EXTERNAL_TABLE_NAME = "allMedicalPaOrdersForExternalByAlgolia";

/**
 * Manages the search term state for the external PA orders table,
 * initializing from persisted table context if available.
 *
 * @returns The current search term and its setter
 */
export const useExternalSearchTerm = () => {
  const { getTableDataFromContext } = useTablesContext();
  const tableAttributes = getTableDataFromContext(EXTERNAL_TABLE_NAME);

  const [searchTerm, setSearchTerm] = useState(
    tableAttributes?.searchedText ?? "",
  );

  return { searchTerm, setSearchTerm };
};
